/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { notitficationActionTypes } from '../../constants';
import { Notification } from '../../types';

export interface NotificationAction {
  type: string;
  payload?: Partial<Notification>;
}

const initialState: Notification[] = [];

export const notification = (state: Notification[] = initialState, action: NotificationAction) => {
  switch (action.type) {
    case notitficationActionTypes.ADD_NOTIFICATION:
      return action.payload ? [...state, action.payload as Notification] : state;
    case notitficationActionTypes.REMOVE_NOTIFICATION:
      return action.payload?.id !== undefined
        ? state.filter((noti) => noti.id !== action.payload?.id)
        : state;
    default:
      return state;
  }
};
